import { gql } from "@/apis/nannyml";

export const deleteUserApiToken = gql(/* GraphQL */ `
  mutation deleteUserApiToken($input: ID!) {
    delete_user_api_token(tokenId: $input) {
      __typename
    }
  }
`);
